import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/common/components/localized-client-link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/products/components/image-gallery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/products/components/product-actions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/products/components/product-preview/index.tsx");
